import { Component } from '@angular/core'
import { MessageComponent } from '../message/message.component'

@Component({
    selector: 'mga-success',
    templateUrl: '../message/message.component.html',
    styleUrls: ['../message/message.component.scss', './success.component.scss'],
})
export class SuccessComponent extends MessageComponent {
    icon = 'check'
}
